import { Ds } from "@accurx/design";
import { DropdownItem } from "domains/message-component/components/DropdownItem";
import styled from "styled-components";

export const StyledContainer = styled(Ds.Flex).attrs({
    gap: "0.5",
    flexDirection: "column",
})`
    border-top: 1px solid var(--ds-color-silver);
    padding-top: 0.25rem;
`;

export const StyledDropdownItemButton = styled(DropdownItem.Button)`
    justify-content: flex-start;
`;
